import { Box, Grid, Typography, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import dayjs from "dayjs";
import React, { useState } from "react";
import { maskSSN, isMaskedSSN, extractLastFourFromMasked } from "utils/Helpers";

const Formation1099 = ({ sheetData }) => {
  const [visibleSSNs, setVisibleSSNs] = useState(new Set());
  
  const toggleSSNVisibility = (index) => {
    setVisibleSSNs(prev => {
      const newSet = new Set(prev);
      if (newSet.has(index)) {
        newSet.delete(index);
      } else {
        newSet.add(index);
      }
      return newSet;
    });
  };
  
  console.log(sheetData, "sheetData");
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Typography sx={{ fontSize: "20px", fontWeight: "600", color: "#000" }}>
          Tax Year:{" "}
          <span style={{ fontWeight: "400" }}>
            {sheetData?.taxYear}
          </span>
        </Typography>
      </Box>
      {sheetData.businessInfoArr.map((item, i) => {
        return (
          <>
            <Box
              sx={{
                background: "#EFF3FD99",
                padding: "20px",
                borderRadius: "12px",
                width: "100%",
              }}
            >
              <Box
                sx={{
                  background: "#0B2558",
                  height: "40px",
                  padding: "0 20px",
                  fontSize: "18px",
                  fontWeight: "600",
                  color: "#fff",
                  borderRadius: "12px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "start",
                }}
              >
                Vendors{i == 0 ? "" : i + 1} Information
              </Box>

              <Grid
                container
                spacing={2}
                borderBottom={"1px solid #00000033"}
                padding={"10px 20px"}
              >
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      First Name
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.firstName}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Middle Name
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.middleName}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Last Name
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.lastName}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                borderBottom={"1px solid #00000033"}
                padding={"10px 20px"}
              >
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Entity Info
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.entityInfo}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Business Name
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.businessName}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Mobile Number
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.mobileNumber}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                borderBottom={"1px solid #00000033"}
                padding={"10px 20px"}
              >
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      EIN
                    </Typography>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: "400",
                          color: "#1B1B1B",
                        }}
                      >
                        {visibleSSNs.has(i) ? (isMaskedSSN(item?.ssn) ? extractLastFourFromMasked(item?.ssn) : (item?.ssn ?? "—")) : (isMaskedSSN(item?.ssn) ? item?.ssn : maskSSN(item?.ssn))}
                      </Typography>
                      <IconButton
                        size="small"
                        onClick={() => toggleSSNVisibility(i)}
                        style={{ padding: '2px' }}
                      >
                        {visibleSSNs.has(i) ? (
                          <Visibility fontSize="small" />
                        ) : (
                          <VisibilityOff fontSize="small" />
                        )}
                      </IconButton>
                    </div>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Street
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.street}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      City
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.city}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                borderBottom={"1px solid #00000033"}
                padding={"10px 20px"}
              >
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      State
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.state}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      Zip Code
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.zipCode}
                    </Typography>
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <div>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "600",
                        color: "#1B1B1B",
                      }}
                    >
                      All Money Paid
                    </Typography>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: "400",
                        color: "#1B1B1B",
                      }}
                    >
                      {item?.amountPaid}
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </Box>
          </>
        );
      })}
    </>
  );
};

export default Formation1099;
